import { useRFS } from "@/api/rfs";
import { Bpmn } from "@/components/ui/bpmn";
import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { H2 } from "@/components/ui/typography";
import { InformationPanel } from "@/features/rfs/InformationPanel";
import { PrepareAndValidatePanel } from "@/features/rfs/PrepareAndValidatePanel";
import { StatusPanel } from "@/features/rfs/StatusPanel";
import { MISSING_ID_IN_ROUTE, STATUS } from "@/utils/constant";
import { useParams, useSearchParams } from "react-router-dom";

export function RFSDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }
  const [searchParams, setSearchParams] = useSearchParams(
    new URLSearchParams("tab=rfs-process"),
  );

  const { data: rfs } = useRFS({ id });

  const tabs = [
    {
      label: "Information",
      value: "information",
      panel: <InformationPanel />,
    },
    {
      label: "RFS Process",
      value: "rfs-process",
      panel: <StatusPanel />,
    },
  ];

  if (rfs?.statusRfsSubmission === STATUS.RFS.GENERATING_HPDB) {
    tabs.splice(1, 0, {
      label: "Prepare & Validate",
      value: "prepare-validate",
      panel: <PrepareAndValidatePanel />,
    });
  }

  function handleTabChange(value: string) {
    setSearchParams({ tab: value });
  }

  return (
    <div className="print:hidden">
      <Breadcrumbs
        list={[
          {
            label: "RFS",
          },
          {
            href: "/rfs/rfs",
            label: "RFS List",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>RFS Detail - {rfs?.clusterId}</H2>
      <Bpmn
        url={import.meta.env.VITE_API_BASE + "/bpmn/Rfs"}
        businessKey={id}
      />
      <Tabs
        value={searchParams.get("tab") ?? "information"}
        onValueChange={handleTabChange}
        className="w-full"
      >
        <TabsList className="sticky top-12 flex justify-start py-4">
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value}>
            {tab.panel}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
